import { create } from "zustand";

const useUserStore = create((set) => ({
  userInfo: {
    addresses: [],
    customer_type_id: 2,
    customer_type_name: "",
    id: "",
    uid: "",
    merchant_data: [],
    phone_numbers: [],
    rank: [],
    signup_date: "",
    scopes: {},
    status: [],
    user_info: {
      complete_name: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      address: "",
      country: "",
      city: "",
      state_province: "",
      postal_code: "",
      tad_id: "",
      company_name: "",
      email_address: "",
      language: "",
      birth_data: "",
      profile_image: "",
      web_alias: "",
      customer_data: "",
      sponsorId: "",
      password: "",
    },
  },
  updateUser: (newUser) => {
    set({ userInfo: newUser });
  },
}));
export default useUserStore;

